import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Icon, useStyleConfig } from '@chakra-ui/react';
import { Icons } from '@codametrix/ui-components';
function CreateViewBox(fidelity) {
    let viewBoxSettings;
    switch(fidelity){
        case 'detailed':
            viewBoxSettings = '0 0 32 32';
            break;
        case 'standard':
            viewBoxSettings = '0 0 20 20';
            break;
        default:
            viewBoxSettings = '0 0 20 20';
            break;
    }
    return viewBoxSettings;
}
function CMXIconComponent(props) {
    const { iconName, size, variant, fidelity, ...rest } = props;
    let viewBoxSettings = CreateViewBox(fidelity || 'standard');
    const styles = useStyleConfig('CMXIconStyles', {
        size,
        variant
    });
    return /*#__PURE__*/ _jsx(Icon, {
        __css: styles,
        viewBox: viewBoxSettings,
        role: "img",
        ...rest,
        children: Icons[iconName]()
    });
}
export { CMXIconComponent };
